export const sharedZh = {
  status: {
    all: '全部',
    allStatus: '全部状态',
    allCountries: '全部国家',
    success: '成功',
    failed: '失败',
    unknown: '未知',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    sending: '发送中',
    timeoutNoReceipt: '超时无回执',
    waitingForReceipt: '等待回执',
    sendSuccess: '发送成功',
    sendFailed: '发送失败',
    processing: '处理中',
    completed: '已完成',
    pending: '待导出',
    marketing: '营销',
    otp: '验证码',
    delivered: '已送达',
    realtime: '实时',
    today: '今天',
  },
  filter: {
    timeRange: '时间范围',
    selectTimeRange: '选择时间范围',
    msgType: '短信类型',
    country: '国家',
    batchId: '批次号',
    phone: '手机号',
    content: '内容',
    senderId: 'SenderID',
    sendContent: '发送内容',
    progressStatus: '进度状态',
    submitStatus: '提交状态',
    deliveryStatus: '送达状态',
    status: '状态',
    searchRecordName: '搜索记录名称',
    inputBatchId: '输入批次号',
    countryPlaceholder: '区号或国家名称',
    phoneSuffixSearch: '末尾模糊搜索',
    fuzzySearch: '支持模糊搜索',
    headerFuzzySearch: '头部模糊搜索',
  },
  table: {
    time: '时间',
    action: '操作',
    detail: '详情',
    view: '查看',
    download: '下载',
    prevPage: '上一页',
    nextPage: '下一页',
    recordsCount: '共 {n} 条记录',
    pageRange: '第 {from}-{to} 条，共 {n} 条',
    noResults: '暂无搜索结果',
    adjustFilters: '请尝试调整筛选条件后重新搜索',
    taskId: '任务ID',
    total: '总数',
    success: '成功',
    failed: '失败',
    progress: '进度',
    sendCount: '发送数量',
    createTime: '创建时间',
    fee: '消耗费用',
    sendContent: '发送内容',
    serialNo: '序号',
    fileName: '文件名',
    exportTime: '导出时间',
    recordCount: '记录数',
    fileSize: '文件大小',
    rank: '排名',
    percentage: '占比',
    sendVolume: '发送量',
  },
  msgType: {
    all: '全部',
    marketing: '营销',
    otp: '验证码',
  },
  timeFilter: {
    today: '今日',
    days7: '7日',
    days30: '30日',
    thisMonth: '本月',
  },
  batchDetail: {
    title: '批次短信详情',
    customerTitle: '客户短信详情',
    customerAccount: '客户账号',
    batchId: '批次号',
    totalExact: '共 {n} 条',
    truncatedHint: '该批次超过 {max} 条，仅展示前 {max} 条',
    refresh: '刷新',
    export: '导出本批',
    exportFailed: '导出失败',
    loadFailed: '加载失败',
    noData: '该批次暂无短信明细',
    close: '关闭',
    autoRefreshing: '自动刷新中',
    tabOverview: '批次概览',
    tabMessages: '短信明细',
    viewDetail: '查看',
    statTotal: '提交总数',
    statSendSuccess: '发送成功',
    statSendFail: '发送失败',
    statWaiting: '等待回执',
    statUnknown: '未知',
    filterAll: '全部',
    contentPreview: '发送内容',
    submitTime: '提交时间',
    subTask: '子任务',
  },
  listMode: {
    label: '列表展示',
    single: '单条明细',
    batch: '批次汇总',
    hintSingle: '每条短信独立一行，展示完整字段',
    hintBatch: '按客户汇总发送量，点击「查看详情」可查看该客户全部短信',
    rowTypeBatch: '批次({n}条)',
    rowTypeSingle: '单条',
    batchCount: '共 {n} 个批次',
  },
}

export const sharedEn = {
  status: {
    all: 'All',
    allStatus: 'All Statuses',
    allCountries: 'All Countries',
    success: 'Success',
    failed: 'Failed',
    unknown: 'Unknown',
    submitSuccess: 'Submitted',
    submitFailed: 'Submit Failed',
    sending: 'Sending',
    timeoutNoReceipt: 'No Receipt',
    waitingForReceipt: 'Awaiting DLR',
    sendSuccess: 'Delivered',
    sendFailed: 'Delivery Failed',
    processing: 'Processing',
    completed: 'Completed',
    pending: 'Pending',
    marketing: 'Marketing',
    otp: 'OTP',
    delivered: 'Delivered',
    realtime: 'Live',
    today: 'Today',
  },
  filter: {
    timeRange: 'Time Range',
    selectTimeRange: 'Select time range',
    msgType: 'Message Type',
    country: 'Country',
    batchId: 'Batch ID',
    phone: 'Phone Number',
    content: 'Content',
    senderId: 'Sender ID',
    sendContent: 'Message Content',
    progressStatus: 'Progress',
    submitStatus: 'Submit Status',
    deliveryStatus: 'Delivery Status',
    status: 'Status',
    searchRecordName: 'Search by file name',
    inputBatchId: 'Enter batch ID',
    countryPlaceholder: 'Country code or name',
    phoneSuffixSearch: 'Suffix match',
    fuzzySearch: 'Fuzzy search supported',
    headerFuzzySearch: 'Prefix match',
  },
  table: {
    time: 'Time',
    action: 'Action',
    detail: 'Details',
    view: 'View',
    download: 'Download',
    prevPage: 'Previous',
    nextPage: 'Next',
    recordsCount: '{n} records',
    pageRange: '{from}-{to} of {n}',
    noResults: 'No results found',
    adjustFilters: 'Try adjusting your filters and search again',
    taskId: 'Task ID',
    total: 'Total',
    success: 'Success',
    failed: 'Failed',
    progress: 'Progress',
    sendCount: 'Sent',
    createTime: 'Created',
    fee: 'Cost',
    sendContent: 'Content',
    serialNo: 'No.',
    fileName: 'File Name',
    exportTime: 'Exported',
    recordCount: 'Records',
    fileSize: 'Size',
    rank: 'Rank',
    percentage: 'Share',
    sendVolume: 'Volume',
    country: 'Country',
  },
  msgType: {
    all: 'All',
    marketing: 'Marketing',
    otp: 'OTP',
  },
  timeFilter: {
    today: 'Today',
    days7: '7 Days',
    days30: '30 Days',
    thisMonth: 'This Month',
  },
  batchDetail: {
    title: 'Batch SMS Details',
    customerTitle: 'Customer SMS Details',
    customerAccount: 'Account',
    batchId: 'Batch ID',
    totalExact: '{n} records',
    truncatedHint: 'This batch has more than {max} records; showing the first {max}',
    refresh: 'Refresh',
    export: 'Export Batch',
    exportFailed: 'Export failed',
    loadFailed: 'Failed to load',
    noData: 'No messages in this batch',
    close: 'Close',
    autoRefreshing: 'Auto-refreshing',
    tabOverview: 'Overview',
    tabMessages: 'Messages',
    viewDetail: 'View',
    statTotal: 'Submitted',
    statSendSuccess: 'Delivered',
    statSendFail: 'Failed',
    statWaiting: 'Awaiting DLR',
    statUnknown: 'Unknown',
    filterAll: 'All',
    contentPreview: 'Content',
    submitTime: 'Submitted',
    subTask: 'Sub-tasks',
  },
  listMode: {
    label: 'List view',
    single: 'Single messages',
    batch: 'Batch summary',
    hintSingle: 'One row per message with full details',
    hintBatch: 'One row per submission; click View for sub-tasks',
    rowTypeBatch: 'Batch ({n})',
    rowTypeSingle: 'Single',
    batchCount: '{n} batches',
  },
}

export const sharedJa = {
  status: {
    all: 'すべて',
    allStatus: 'すべてのステータス',
    allCountries: 'すべての国',
    success: '成功',
    failed: '失敗',
    unknown: '不明',
    submitSuccess: '送信成功',
    submitFailed: '送信失敗',
    sending: '送信中',
    timeoutNoReceipt: '受信なし',
    waitingForReceipt: '受信待ち',
    sendSuccess: '配信成功',
    sendFailed: '配信失敗',
    processing: '処理中',
    completed: '完了',
    pending: '待機中',
    marketing: 'マーケティング',
    otp: 'OTP',
    delivered: '配信済み',
    realtime: 'リアルタイム',
    today: '今日',
  },
  filter: {
    timeRange: '期間',
    selectTimeRange: '期間を選択',
    msgType: 'SMSタイプ',
    country: '国',
    batchId: 'バッチID',
    phone: '電話番号',
    content: '内容',
    senderId: 'Sender ID',
    sendContent: 'SMS内容',
    progressStatus: '進捗',
    submitStatus: '送信ステータス',
    deliveryStatus: '配信ステータス',
    status: 'ステータス',
    searchRecordName: 'ファイル名で検索',
    inputBatchId: 'バッチIDを入力',
    countryPlaceholder: '国コードまたは国名',
    phoneSuffixSearch: '末尾一致',
    fuzzySearch: 'あいまい検索対応',
    headerFuzzySearch: '先頭一致',
  },
  table: {
    time: '時間',
    action: '操作',
    detail: '詳細',
    view: '表示',
    download: 'ダウンロード',
    prevPage: '前へ',
    nextPage: '次へ',
    recordsCount: '{n} 件',
    pageRange: '{from}-{to} / {n} 件',
    noResults: '結果がありません',
    adjustFilters: 'フィルターを調整して再検索してください',
    taskId: 'タスクID',
    total: '合計',
    success: '成功',
    failed: '失敗',
    progress: '進捗',
    sendCount: '送信数',
    createTime: '作成日時',
    fee: '費用',
    sendContent: '内容',
    serialNo: '番号',
    fileName: 'ファイル名',
    exportTime: 'エクスポート日時',
    recordCount: '件数',
    fileSize: 'サイズ',
    rank: '順位',
    percentage: '割合',
    sendVolume: '送信量',
    country: '国',
  },
  msgType: {
    all: 'すべて',
    marketing: 'マーケティング',
    otp: 'OTP',
  },
  timeFilter: {
    today: '今日',
    days7: '7日',
    days30: '30日',
    thisMonth: '今月',
  },
  batchDetail: {
    title: 'バッチSMS詳細',
    customerTitle: '顧客SMS詳細',
    customerAccount: 'アカウント',
    batchId: 'バッチID',
    totalExact: '{n} 件',
    truncatedHint: 'このバッチは {max} 件を超えています。先頭 {max} 件のみ表示',
    refresh: '更新',
    export: 'バッチをエクスポート',
    exportFailed: 'エクスポート失敗',
    loadFailed: '読み込み失敗',
    noData: 'このバッチにSMS明細がありません',
    close: '閉じる',
    autoRefreshing: '自動更新中',
    tabOverview: '概要',
    tabMessages: 'SMS明細',
    viewDetail: '表示',
    statTotal: '送信総数',
    statSendSuccess: '配信成功',
    statSendFail: '配信失敗',
    statWaiting: '受信待ち',
    statUnknown: '不明',
    filterAll: 'すべて',
    contentPreview: '内容',
    submitTime: '送信時間',
    subTask: 'サブタスク',
  },
  listMode: {
    label: 'リスト表示',
    single: '単件明細',
    batch: 'バッチ集計',
    hintSingle: '1件ずつ全項目を表示',
    hintBatch: '同一送信を1行に集約、サブタスクを表示可能',
    rowTypeBatch: 'バッチ({n}件)',
    rowTypeSingle: '単件',
    batchCount: '{n} バッチ',
  },
}
